<template>
        <div class="form-layout account-details" v-if="required_fields != null && honorifics.length > 0 && traffic_sources.length > 0">

            <!-- Name and title fields -->
            <div class="form-rows form-section" v-if="(required_fields['honorific_id'] || required_fields['first_name'] || required_fields['last_name'])">
                <div class="fields dropdown nametitle" v-if="required_fields['honorific_id']" :class="{'has-error': errors.has('honorific_id') }">
                    <label for="honorific_id">{{ locale.text_title_label }} <span v-if="required_fields['honorific_id']">*</span></label>

                    <div class="dropdown-inner" v-if="honorifics.length > 0">
                        <select name="honorific_id" id="honorific_id" v-model="user.honorific_id" v-validate="{ rules: { required: required_fields['honorific_id'] } }">
                            <option value="" disabled selected>-- Title --</option>
                            <option v-for="honorific in honorifics" :value="honorific.id">{{ honorific.name }}</option>
                        </select>

                        <i class="fa fa-chevron-down"></i>
                    </div>
                    <p class="text-danger" v-if="errors.has('honorific_id')">{{ errors.first('honorific_id') }}</p>
                </div>

                <div class="fields input firstname" v-if="required_fields['first_name']" :class="{'has-error': errors.has('first_name') }">
                    <label for="first_name">{{ locale.text_first_name_label }} <span v-if="required_fields['first_name']">*</span></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['first_name'], max: 40 } }" name="first_name" id="first_name" :placeholder="locale.text_first_name_label" v-model="user.first_name"/>
                    <p class="text-danger" v-if="errors.has('first_name')">{{ errors.first('first_name') }}</p>
                </div>

                <div class="fields input surname" v-if="required_fields['last_name']" :class="{'has-error': errors.has('last_name') }">
                    <label for="last_name">{{ locale.text_last_name_label }} <span v-if="required_fields['last_name']">*</span></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['last_name'], max: 40 } }" name="last_name" id="last_name" :placeholder="locale.text_last_name_label" v-model="user.last_name"/>
                    <p class="text-danger" v-if="errors.has('last_name')">{{ errors.first('last_name') }}</p>
                </div>
            </div>

            <div class="form-rows" v-if="(required_fields['mobile'] || required_fields['child_relationship']) || $route.name == 'account.details'">
                <div class="fields input half left" v-if="required_fields['mobile'] || $route.name == 'account.details'" :class="{'has-error': errors.has('mobile') }">
                    <label for="mobile">{{ locale.text_mobile_label }} <span v-if="required_fields['mobile']">*</span></label>
                    <input type="tel" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['mobile'], max: 45, min: 5 } }" name="mobile" id="mobile" :placeholder="locale.text_mobile_label_placeholder" v-model="user.mobile"/>
                    <p class="text-danger" v-if="errors.has('mobile')">{{ errors.first('mobile') }}</p>
                </div>

                <div class="fields input half right" v-if="required_fields['child_relationship'] || $route.name == 'account.details'" :class="{'has-error': errors.has('child_relationship') }">
                    <label for="child_relationship">{{ locale.child_relationship_label }} <span v-if="required_fields['child_relationship']">*</span></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['child_relationship'], max: 45, min: 5 } }" name="child_relationship" id="child_relationship" :placeholder="locale.child_relationship_label" v-model="user.child_relationship"/>
                    <p class="text-danger" v-if="errors.has('child_relationship')">{{ errors.first('child_relationship') }}</p>
                </div>
                
            </div>

            <div class="form-rows" v-if="show_military_fields || user.military_service_number || user.military_service_rank">
                <div class="fields input half left" v-if="true" :class="{'has-error': errors.has('military_service_number') }">
                    <label for="military_service_number">{{ locale.text_military_service_number_label }} <small>(Only required for serving personnel)</small></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: true } }" name="military_service_number" id="military_service_number" :placeholder="locale.text_military_service_number_label" v-model="user.military_service_number"/>
                    <p class="text-danger" v-if="errors.has('military_service_number')">{{ errors.first('military_service_number') }}</p>
                </div>

                <div class="fields input half right" v-if="true" :class="{'has-error': errors.has('military_service_rank') }">
                    <label for="military_service_rank">{{ locale.text_military_service_rank_label }} <small>(Only required for serving personnel)</small></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: true } }" name="military_service_rank" id="military_service_rank" :placeholder="locale.text_military_service_rank_label" v-model="user.military_service_rank"/>
                    <p class="text-danger" v-if="errors.has('military_service_rank')">{{ errors.first('military_service_rank') }}</p>
                </div>

                <div class="fields dropdown half" v-if="true" :class="{'has-error': errors.has('military_service_type_id') }">
                    <label for="military_service_type_id">{{ locale.text_military_service_type_label }} <small>(Only required for serving personnel)</small></label>

                    <div class="dropdown-inner">
                        <select name="military_service_type_id" id="military_service_type_id" v-validate="{ rules: { required: required_fields['military_service_type_id']} }" v-model="user.military_service_type_id">
                            <option v-for="service_type in military_service_types" :value="service_type.id">{{ service_type.name }}</option>
                        </select>
                        <p class="text-danger" v-if="errors.has('military_service_type_id')">{{ errors.first('military_service_type_id') }}</p>

                        <i class="fa fa-chevron-down"></i>
                    </div>
                </div>
            </div>

            <p v-if="this.$root.authenticated" class="parents-nominee-question"> {{ locale.text_add_nominee_label }}</p>

            <!-- Nominee details -->
            <div v-if="this.$root.authenticated" class="form-rows">
                <div class="fields input half left" :class="{'has-error': errors.has('nominee_name') }">
                    <label for="nominee_name">{{ locale.text_nominee_name_label }} <span v-if="required_fields['nominee_name']">*</span></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['nominee_name'] } }" name="nominee_name" id="nominee_name" :placeholder="locale.text_nominee_name_label" v-model="user.nominee_name"/>
                    <p class="text-danger" v-if="errors.has('nominee_name')">{{ errors.first('nominee_name') }}</p>
                </div>

                <div class="fields input half right" :class="{'has-error': errors.has('nominee_contact') }">
                    <label for="nominee_contact">{{ locale.text_nominee_contact_label }} <span v-if="required_fields['nominee_contact']">*</span></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['nominee_contact'] } }" name="nominee_contact" id="nominee_contact" :placeholder="locale.text_nominee_contact_label" v-model="user.nominee_contact"/>
                    <p class="text-danger" v-if="errors.has('nominee_contact')">{{ errors.first('nominee_contact') }}</p>
                </div>

                <div class="fields input half left">
                    <label for="nominee_relationship">{{ locale.text_nominee_relationship_label }} <span v-if="required_fields['nominee_relationship']">*</span></label>
                    <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['nominee_relationship'] } }" name="nominee_relationship" id="nominee_relationship" :placeholder="locale.text_nominee_relationship_label" v-model="user.nominee_relationship"/>
                </div>
            </div>


            <!-- Postcode lookup Errors -->
            <transition name="slide-fade">
                <div class="form-rows" v-if="box.show">
                    <div class="box-layout-inner alert">
                        <div class="full-width red">
                            <span v-html="box.message"></span>
                        </div>
                    </div>
                </div>
            </transition>

            <!-- Address Fields -->
            <div class="form-rows form-section" v-if="address_required">

                <transition-group name="slide-fade">
                    <div class="fields input postcode" :class="{'has-error': errors.has('postcode') }" :style="{ 'width': (show_address_fields ? '20%' : null ) }" key="postcode">
                        <label for="postcode">{{ postcode_label }} <span v-if="required_fields['postcode']">*</span></label>
                        <input type="text" @keyup.enter="handlePostcodeLookup" v-validate="{ rules: { required: required_fields['postcode'], max: 10 } }" name="postcode" id="postcode" :placeholder="postcode_label" v-model="user.postcode"/>
                        <p class="text-danger" v-if="errors.has('postcode')">{{ errors.first('postcode') }}</p>
                    </div>

                    <div class="fields dropdown found-address-list" v-if="available_address.length > 0" :style="{ 'width': (show_address_fields ? '56%' : null ) }" key="address-list">
                        <label for="chosen_address">Available addresses</label>

                        <div class="dropdown-inner" v-if="available_address.length > 0">
                            <select name="chosen_address" id="chosen_address" v-model="chosen_address">
                                <option value="" disabled selected>Please choose an address</option>
                                <option v-for="(address, key) in available_address" :value="key">{{ (address.organisation_name ? address.organisation_name + ', ' + address.line_1 : address.line_1) + ', ' + address.town + ', ' + address.postcode }}</option>
                            </select>

                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>

                    <div class="fields input find-address" key="buttons">
                        <input @click="handlePostcodeLookup" type="button" id="find-address-button" value="Find my address" class="cta-button red">
                        <transition name="slide-fade">
                            <span v-if="!show_address_fields"><a @click="show_address_fields = true" class="cta-button blue">Click here, to enter your address manually</a></span>
                        </transition>
                    </div>
                </transition-group>
            </div>

            <transition-group name="list" v-if="address_required">
                <div class="form-rows" v-if="address_required" v-show="show_address_fields" v-bind:key="0">

                    <div class="fields input half left" :class="{'has-error': errors.has('address_line_1') }">
                        <label for="address_line_1">{{ locale.text_address_1_label }} <span v-if="required_fields['address_line_1']">*</span></label>
                        <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['address_line_1'], max: 40} }" name="address_line_1" id="address_line_1" :placeholder="locale.text_address_1_label" v-model="user.address_line_1"/>
                        <p class="text-danger" v-if="errors.has('address_line_1')">{{ errors.first('address_line_1') }}</p>
                    </div>
                    <div class="fields input half right" :class="{'has-error': errors.has('address_line_2') }">
                        <label for="address_line_2">{{ locale.text_address_2_label }} <span v-if="required_fields['address_line_2']">*</span></label>
                        <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['address_line_2'], max: 40 } }" name="address_line_2" id="address_line_2" :placeholder="locale.text_address_2_label" v-model="user.address_line_2"/>
                        <p class="text-danger" v-if="errors.has('address_line_2')">{{ errors.first('address_line_2') }}</p>
                    </div>

                </div>
                <div class="form-rows" v-show="show_address_fields" v-bind:key="2">

                    <div class="fields input half left" :class="{'has-error': errors.has('town') }">
                        <label for="town">{{ locale.text_town_label }} <span v-if="required_fields['town']">*</span></label>
                        <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['town'], max: 40} }" name="town" id="town" :placeholder="locale.text_town_label" v-model="user.town"/>
                        <p class="text-danger" v-if="errors.has('town')">{{ errors.first('town') }}</p>
                    </div>

                    <div class="fields input half right" v-if="!show_state_field" :class="{'has-error': errors.has('county') }">
                        <label for="county">{{ locale.text_county_label }} <span v-if="required_fields['county']">*</span></label>
                        <input type="text" @keyup.enter="handle" v-validate="{ rules: { required: required_fields['county'], max: 40} }" name="county" id="county" :placeholder="locale.text_county_label" v-model="user.county"/>
                        <p class="text-danger" v-if="errors.has('county')">{{ errors.first('county') }}</p>
                    </div>

                    <div class="fields dropdown half right" v-else :class="{'has-error': errors.has('us_state_id') }">
                        <label for="us_state_id">{{ locale.text_state_label }} <span v-if="required_fields['us_state_id']">*</span></label>

                        <div class="dropdown-inner">
                            <select name="us_state_id" id="us_state_id" v-validate="{ rules: { required: required_fields['us_state_id']} }" v-model="user.us_state_id">
                                <option v-for="state in states" :value="state.id">{{ state.name }}</option>
                            </select>
                            <p class="text-danger" v-if="errors.has('us_state_id')">{{ errors.first('us_state_id') }}</p>

                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>
                </div>
                <div class="form-rows" v-bind:key="3">

                    <div class="fields dropdown half" v-show="show_address_fields"  :class="{'has-error': errors.has('country_id'), 'left': this.$root.authenticated }">
                        <label for="country_id">{{ locale.text_country_label }} <span v-if="required_fields['country_id']">*</span></label>

                        <div class="dropdown-inner">
                            <select name="country_id" id="country_id" v-validate="{ rules: { required: required_fields['country_id']} }" v-model="user.country_id">
                                <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
                            </select>
                            <p class="text-danger" v-if="errors.has('country_id')">{{ errors.first('country_id') }}</p>

                            <i class="fa fa-chevron-down"></i>
                        </div>
                    </div>

                    <div class="fields input half" v-if="this.$root.authenticated" :class="{'left': !show_address_fields, 'right': show_address_fields, 'has-error': errors.has('email_address'), 'readonly': $route.name == 'account.details' }">
                        <label for="email_address">{{ locale.text_email_address_label }} <span v-if="required_fields['email_address']">*</span></label>
                        <input type="email" @keyup.enter="handle" v-validate="{ rules: 'required|email' + (!$parent.isCheckout || ($parent.checkout && !this.$root.authenticated) ? '|confirmed:email_confirm' : '') }" name="email_address" id="email_address" :placeholder="locale.text_email_address_label" v-model="user.email_address" :readonly="$route.name == 'account.details'"/>
                        <p class="text-danger" v-if="errors.has('email_address')">{{ errors.first('email_address') }}</p>
                    </div>
                </div>
            </transition-group>

            <!-- Email fields -->
            <div class="form-rows form-section" v-if="!this.$root.authenticated" style="padding-bottom:0px;">
                <div class="fields input half left" :class="{'has-error': errors.has('email_address') }">
                    <label for="email_address">{{ locale.text_email_address_label }} <span v-if="required_fields['email_address']">*</span></label>
                    <input type="email" @keyup.enter="handle" v-validate="{ rules: 'required|email' + (!$parent.isCheckout || ($parent.checkout && !this.$root.authenticated) ? '|confirmed:email_confirm|max:60' : '') }" name="email_address" id="email_address" :placeholder="locale.text_email_address_label" v-model="user.email_address"/>
                    <p class="text-danger" v-if="errors.has('email_address')">{{ errors.first('email_address') }}</p>
                </div>

                <div class="fields input half right" :class="{'has-error': errors.has('email_address') }" v-if="!$parent.isCheckout || ($parent.checkout && !this.$root.authenticated)">
                    <label for="email_confirm">{{ locale.text_confirm_email_address_label }} <span v-if="required_fields['email_address']">*</span></label>
                    <input type="email" @keyup.enter="handle" name="email_confirm" id="email_confirm" :placeholder="locale.text_confirm_email_address_label"/>
                </div>

            </div>

            <!-- Password fields -->
            <div class="form-rows" style="padding-bottom:0px;" v-if="this.$root.authenticated && $route.name == 'account.details'">
                <div class="fields input half">
                    <button type="button" class="cta-button red" @click="change_password = true">Change password</button>
                </div>
            </div>
            <div class="form-rows"  style="padding-bottom:0px;" v-if="($parent.checkout && !this.$root.authenticated) || (!$parent.checkout && change_password) || ($route.name == 'account.details' && change_password)">
                <div class="fields input half left" :class="{'has-error': errors.has('password_clear') }">
                    <label for="password_clear">{{ locale.text_password_label }} <span v-if="$route.name != 'account.details'">*</span></label>
                    <input type="password" @keyup.enter="handle" v-validate="{ rules: { required: $route.name != 'account.details',  max: 20, min: 8, password: true, confirmed: 'password_confirm' } }" name="password_clear" id="password_clear" :placeholder="locale.text_password_label" v-model="user.password_clear"/>
                    <p class="text-danger" v-if="errors.has('password_clear')">{{ errors.first('password_clear') }}</p>
                </div>

                <div class="fields input half right" :class="{'has-error': errors.has('password_clear') }">
                    <label for="password_confirm">{{ locale.text_confirm_password_label }} *</label>
                    <input type="password" @keyup.enter="handle" name="password_confirm" id="password_confirm" :placeholder="locale.text_confirm_password_label"/>
                </div>
            </div>

            <!-- Form submit buttons -->
            <div class="form-rows" v-show="required_fields['traffic_source_id'] && !$root.authenticated" >
                <div class="fields dropdown" :class="{'has-error': errors.has('traffic_source_id') }">
                    <label for="traffic_source_id">{{ locale.text_traffic_source_label }} <span v-if="required_fields['traffic_source_id']">*</span></label>

                    <div class="selection-options">
                        <div class="fields selection" v-for="traffic_source in traffic_sources" :class="{ 'checked': traffic_source.id == user.traffic_source_id }">
                            <input type="radio" name="traffic_source_id" :id="'traffic_source_id'+traffic_source.id" :value="traffic_source.id" v-model="user.traffic_source_id" v-validate="{ rules: { required: required_fields['traffic_source_id'] } }">

                            <label :for="'traffic_source_id'+traffic_source.id" @click="$validator.validate('traffic_source_id', 'required')">
                                <div class="checkbox"></div>
                                <div class="title">{{ traffic_source.name }}</div>
                            </label>
                        </div>
                    </div>
                    <p class="text-danger" v-if="errors.has('traffic_source_id')">{{ errors.first('traffic_source_id') }}</p>
                </div>
            </div>
            <div class="form-rows">
                <div class="ico-marketing" v-if="(!$parent.isCheckout || ($parent.isCheckout && !$root.authenticated)) || $route.name == 'account.details'">
                    <p v-html="optinText"></p>
                    <p v-show="change_optins"><b v-html="locale.text_optin_line_2"></b></p>
                    <ul v-show="change_optins">
                        <li>
                            <label for="can_contact_email">
                                <input type="checkbox" value="email" name="can_contact_email" id="can_contact_email" v-model="optins">
                                {{ locale.text_optin_option_email }}
                            </label>
                        </li>
                        <li>
                            <label for="can_contact_sms">
                                <input type="checkbox" value="sms" name="can_contact_sms" id="can_contact_sms" v-model="optins">
                                {{ locale.text_optin_option_sms }}
                            </label>
                        </li>
                        <li>
                            <label for="can_contact_post">
                                <input type="checkbox" value="post" name="can_contact_post" id="can_contact_post" v-model="optins">
                                {{ locale.text_optin_option_post }}
                            </label>
                        </li>
                        <li>
                            <label for="can_contact_call">
                                <input type="checkbox" value="call" name="can_contact_call" id="can_contact_call" v-model="optins">
                                {{ locale.text_optin_option_phone }}
                            </label>
                        </li>
                        <li>
                            <label for="can_contact_whatsapp">
                                <input type="checkbox" value="whatsapp" name="can_contact_whatsapp" id="can_contact_whatsapp" v-model="optins">
                                {{ locale.text_optin_option_whatsapp }}
                            </label>
                        </li>
                    </ul>
                    <p v-show="change_optins" v-html="optinText3"></p>
                    <p v-show="change_optins" v-html="locale.text_optin_line_4"></p>
                    <p v-show="change_optins"><small v-html="locale.text_optin_line_5"></small></p>

                </div>
            </div>
            <div class="form-rows last">
                <div class="fields input half" :class="{ 'right': required_fields['traffic_source_id'] && !$root.authenticated }">
                    <button type="button" class="cta-button blue loading" v-if="loading_icon" disabled><p><i class="fa fa-spinner fa-pulse"></i></p></button>
                    <input type="button" @click="loading_icon = true; handle()" class="cta-button blue" id="register" :value="($parent.checkout && $root.authenticated ? 'Confirm details' : ($route.name == 'account.details' ? 'Update details' : 'Register'))" v-else/>
                </div>
            </div>

        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
            <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
        </div>
</template>

<script>
    export default {
        data () {
            return {
                user: {
                    country_id: 225
                },
                change_password: this.$route.name != 'account.details',

                //Lookups data
                required_fields: null,
                honorifics: {},
                traffic_sources: {},
                military_service_types: {},
                countries: {},
                states: {},

                show_state_field: false,

                optins: [
                    "email",
                    "sms",
                    "post",
                    "call",
                    "whatsapp"
                ],
                change_optins: true,

                chosen_address: "",
                show_address_fields: false,

                available_address: [],

                loading_icon: false,

                show_military_fields: false,

                booking_id: this.$root.getCookie('kingscamps_booking_id'),

                box: { show: false, message: "" }
            }
        },
        computed: {
            optinText: function () {
                return this.locale.text_optin_line_1.replace(':clickHere', '<a id="changeOptins">click here</a>');
            },
            optinText3: function () {
                return this.locale.text_optin_line_3.replace(':clickHere', '<a target="_blank" href="https://www.kingscamps.org/web-policies/">here</a>');
            },
            locale: function () {
                return this.$root.locale.account.register;
            },
            postcode_label: function () {
                switch(this.user.country_id) {
                    case 226:
                        this.show_state_field = true;
                        this.user.county = "";
                        return this.locale.text_zipcode_label;
                    default:
                        this.show_state_field = false;
                        this.user.us_state_id = "";
                        return this.locale.text_postcode_label;
                }
            },
            address_required: function () {
                var fields = ['address_line_1', 'address_line_2', 'town', 'county', 'country_id', 'postcode']
                var check = false;
                fields.forEach(field => {
                    if(this.required_fields[field])
                        check = true;
                })
                return check || this.$route.name == 'account.details';
            }
        },
        watch: {
            //WATCH THE BASKETS ARRAY AND FORMAT IT TO BE A LIST OF PARTICIPANTS WITH THEIR ITEMS
            'bookings' () {
                // console.log('bookings updated: ', this.bookings);
            },
            'show_military_fields' () {
                required_fields['military_service_number'] = true;
                required_fields['military_service_rank'] = true;
                required_fields['military_service_type_id'] = true;
            }
        },
        created () {
            this.show_address_fields = (this.$parent.isCheckout && this.$root.authenticated && this.$root.auth.town) || this.user.town;

            /**
             * Getting the required fields to create a new user.
             **/
            var booking_id = this.$root.getCookie('kingscamps_booking_id');
            var booking_user_id = this.$root.getCookie('booking_user_id');
            if(this.$root.authenticated) {
                //Getting the required fields for this user
                axios.get('camp-booking/users/'+this.$root.auth.user_id+'/required-fields')
                    .then(response => {
                        this.required_fields = response.data.data;

                        /** Setting up the user object with all user properties **/
                        this.user = Object.assign(this.user, this.$root.auth);

                        this.optins = [];
                        Object.keys(this.user).forEach(field => {
                            if(field.includes('can_contact_') && field.includes('email') && this.user['can_contact_email'] == true)
                                this.optins.push('email')
                            else if(field.includes('can_contact_') && field.includes('sms') && this.user['can_contact_sms'] == true)
                                this.optins.push('sms')
                            else if(field.includes('can_contact_') && field.includes('call') && this.user['can_contact_call'] == true)
                                this.optins.push('call')
                            else if(field.includes('can_contact_') && field.includes('post') && this.user['can_contact_post'] == true)
                                this.optins.push('post')
                            else if(field.includes('can_contact_') && field.includes('whatsapp') && this.user['can_contact_whatsapp'] == true)
                                this.optins.push('whatsapp')

                        })
                    })

                //Checking whether this user should fill in the military fields
                axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/basket')
                    .then(response => {

                        //If there are items in the basket we should then check
                        if(response.data.data.number_of_items_in_basket > 0) {
                            axios.get('/camp-booking/bookings/' + response.data.data.booking_id + '/items')
                                .then(response => {
                                    response.data.data.forEach(item => {
                                        if(item.is_military == true) {
                                            this.show_military_fields = true;
                                        }
                                    })
                                })
                        }
                    })
            } else {
                //Getting the general required fields for a user
                axios.get('camp-booking/users/required-fields' + (booking_id && booking_id != 'null' && ((!booking_user_id || booking_user_id == 'null') && this.$parent.isCheckout) ? '?guest_booking_id='+booking_id : ''))
                    .then(response => {
                        this.required_fields = response.data.data;

                        /** Setting up the user object with all user properties **/
                        Object.keys(this.required_fields).forEach(field => {
                            if(field.includes('can_contact_'))
                                this.user[field] = 0;
                            else
                                this.user[field] = "";
                        })
                    })

                //TODO: Check here if the basket has any venues that are military
                var booking_id = (this.$route.params.hasOwnProperty('bookingId') ? this.$route.params.bookingId : ( this.$route.query.hasOwnProperty('bookingId') ? this.$route.query.bookingId : (this.booking_id ? this.booking_id : null)));

                //If there are items in the basket we should then check
                if(booking_id != null && booking_id > 0) {
                    axios.get('/camp-booking/bookings/' + booking_id + '/items')
                        .then(response => {
                            response.data.data.forEach(item => {
                                if(item.military_venue == true) {
                                    this.show_military_fields = true;
                                }
                            })
                        })
                }
            }

            /**
             * Getting all honorifics from the api for form.
             * */
            axios('camp-booking/lookups/honorifics')
                .then(response => {
                    this.honorifics = response.data.data;
                })

            /**
             * Getting all traffic sources from the api for form.
             * */
            axios('camp-booking/lookups/traffic-sources')
                .then(response => {
                    this.traffic_sources = response.data.data;
                })

            /**
             * Getting all countries from the api for form.
             * */
            axios('camp-booking/lookups/countries')
                .then(response => {
                    this.countries = response.data.data;
                    var UK = $.grep(this.countries, function(e){ return e.iso2 == 'GB'; });
                    this.countries.splice(UK[0].id-1, 1);
                    this.countries.unshift(UK[0]);
                    this.user.country_id = UK[0].id;
                })
            
            /**
             * Getting all military service types from the api for form.
             * */
            axios('camp-booking/lookups/military-service-types')
                .then(response => {
                    this.military_service_types = response.data.data;
                })

            /**
             * Getting all states from the api for form.
             * */
            axios('camp-booking/lookups/united-states-of-america-states')
                .then(response => {
                    this.states = response.data.data;
                })
        },
        watch: {
            'chosen_address': function () {
                var address = this.available_address[this.chosen_address];

                if(!address)
                    return false;

                this.user.address_line_1 = (address.organisation_name ? address.organisation_name + ', ' + address.line_1 : address.line_1).substring(0, 40);
                this.user.address_line_2 = address.line_2.substring(0, 40);
                this.user.town = address.town.substring(0, 40);
                this.user.county = address.postal_county.substring(0, 40);

                this.show_address_fields = true;
            }
        },
        methods: {
            handlePostcodeLookup: function () {
                this.show_address_fields = false;
                this.$validator.validate('postcode', this.user.postcode);
                this.available_address = [];
                var postcode = this.user.postcode.toUpperCase().replace(/[^\w\s]/gi, '').replace(' ', '');
                if(postcode)
                    axios.get('/system/maps/address-lookup/full/'+postcode)
                        .then(response => {
                            if(response.data.data.length > 0)
                                this.available_address = response.data.data;
                            this.chosen_address = "";
                        }).catch(error => {
                            this.box = { show: true, message: 'Could not find a matching postcode, please check your spelling or enter your address manually' };
                            this.show_address_fields = true;

                            setTimeout(() => {
                                this.box = { show: false, message: '' };
                            }, 5000);
                        })
            },
            handle: _.debounce(
                function () {

                    /**
                     * Obviously don't want to continue if there are errors.
                     */
                    this.$validator.validateAll();
                    if(this.errors.errors.length) {
                        this.$root.alert('Please check the form for errors', 'danger', false, false);

						//Is the user trying to proceed with a postcode in, having not entered an address?
						if (this.$parent.checkout && this.$root.authenticated) {
							this.show_address_fields = true;
						}

                        setTimeout(() => {
                            $("html, body").animate({scrollTop: $(".has-error").offset().top}, "slow");
                        }, 1000);
                        this.loading_icon = false;
                        return false;
                    }

                    /**
                     * Submitting! :)
                     */
                    if(this.user.password_clear == "" && this.$route.name == 'account.details')
                        this.user.password_clear = undefined;
                    if(this.$parent.isCheckout && this.$root.authenticated) {
                        //Matching optins array to the user model
                        Object.keys(this.required_fields).forEach(field => {
                            if(field.includes('can_contact_')) {
                                if (this.optins.indexOf(field.substr(field.indexOf("can_contact_") + 12)) > -1)
                                    this.user[field] = 1;
                                else
                                    this.user[field] = 0;
                            }
                        });
                        axios.patch('camp-booking/users/'+this.$root.auth.user_id, this.user)
                            .then(response => {
                                this.$root.alert("Thank you for confirming your details.", 'success');
                                this.$emit('registered', response.data.data);
                                if(this.$route.name == 'account.details')
                                    this.$router.push({ name: 'account.overview' });
                                this.loading_icon = false;
                            }).catch(error => {
                                var object = error.response.data.data.message;
                                var errors = [];
                                for (var property in object) {
                                    if (object.hasOwnProperty(property)) {
                                        for (var error in object[property]) {
                                            errors.push(object[property][error]);
                                        }
                                    }
                                }
                                $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                                this.$root.alert(errors, 'danger', false);
                                this.loading_icon = false;
                            });
                    } else {
                        //Matching optins array to the user model
                        Object.keys(this.required_fields).forEach(field => {
                            if(field.includes('can_contact_')) {
                                if (this.optins.indexOf(field.substr(field.indexOf("can_contact_") + 12)) > -1)
                                    this.user[field] = 1;
                                else
                                    this.user[field] = 0;
                            }
                        });
                        axios.post('camp-booking/users', this.user)
                            .then(response => {
                                this.$root.auth = response.data.data;

                                this.$root.alert("Welcome, " + this.user.first_name + " " + this.user.last_name + "! Your account has been created.", 'success');
                                this.$emit('registered', response.data.data);


                            }).catch(error => {
                                var object = error.response.data.data.message;
                                var errors = [];
                                if(object instanceof Object) {
                                    for (var property in object) {
                                        if (object.hasOwnProperty(property)) {
                                            for (var error in object[property]) {
                                                errors.push(object[property][error]);
                                            }
                                        }
                                    }
                                } else {
                                    errors.push(object);
                                }
                                $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                                this.$root.alert(errors, 'danger', false);
                                this.loading_icon = false;
                            });
                    }

                },
                500
            )
        },
        mounted () {
            $(document).ready(() => {
                $('body').bind("cut copy paste", "#password_confirm, #email_confirm", event => {
                    //Placing a check to make sure this is only being called on the following fields
                    //When progressing to the child details form, this is being set on all fields
                    if(['password_confirm', 'email_confirm'].indexOf($(event.target).attr('id')) > -1) {
                        event.preventDefault();
                    }
                });

                $(document.body).on('click touchend', 'a#changeOptins', () => {
                    this.change_optins = true;
                })
            });
        },
    }
</script>



// WEBPACK FOOTER //
// register.vue?32d1ad66